import { useCallback } from 'react';
import { useSupabaseAuth } from './useSupabaseAuth';
import { getSocket } from '../lib/socket';

/** Sala actual según la URL (/lobby/:id o /match/:id). */
const currentRoomId = (): string | null => /\/(?:lobby|match)\/([^/?#]+)/.exec(window.location.pathname + window.location.hash)?.[1] ?? null;

/**
 * País elegido por el jugador y cómo cambiarlo desde Ajustes: se guarda en el
 * navegador (y en la cuenta) y, si está en una sala o partido, el servidor
 * cambia el uniforme al momento.
 */
export const useCountryChoice = (): [string | null, (country: string | null) => void] => {
  const { player, updateProfile } = useSupabaseAuth();
  const set = useCallback(
    (country: string | null) => {
      const applied = updateProfile({ country });
      const roomId = currentRoomId();
      if (roomId && applied.country !== undefined) {
        void getSocket().then((socket) => socket.emit('lobby:updateProfile', { roomId, country: applied.country }));
      }
    },
    [updateProfile]
  );
  return [player?.avatarConfig.country ?? null, set];
};

/** Rostro elegido (Ajustes): como el país, en el navegador, la cuenta y la sala. */
export const useFaceChoice = (): { face: string | null; seed: string; color: string; set: (face: string | null) => void } => {
  const { player, updateProfile } = useSupabaseAuth();
  const set = useCallback(
    (face: string | null) => {
      const applied = updateProfile({ face });
      const roomId = currentRoomId();
      if (roomId && applied.face !== undefined) {
        void getSocket().then((socket) => socket.emit('lobby:updateProfile', { roomId, face: applied.face }));
      }
    },
    [updateProfile]
  );
  return { face: player?.avatarConfig.face ?? null, seed: player?.id ?? 'invitado', color: player?.avatarConfig.color ?? '#22d3ee', set };
};
